export const getImageSrc = (value) => {
    if (!value) return ''
    if (value.startsWith('data:') || value.startsWith('http://') || value.startsWith('https://')) return value
    return `data:image/png;base64,${value}`
}